export const ACESSO_ADMINISTRATIVO_CLARITY = 'oyl70j3zmf', ACESSO_PUBLICO_CLARITY = 'om5tk0kco4';